import { setUser as setSentryUser } from "@sentry/react"
import trackEvent from "./trackEvent"
import type { Uuid } from "@/utils"

// TODO: Switch to umami.identify when session is not broken by it
// https://github.com/umami-software/umami/issues/3820
export default async (userId: Uuid) => {
  setSentryUser({
    ip_address: "{{auto}}",
    id: userId,
  })
  await trackEvent("auth", { id: userId })
}
